import { default as scroll } from "./modules/_scroll"
import { default as desktopHeader } from "./modules/_desktop-header"

(() => {

    desktopHeader.init()
    scroll.init()
    
})();